module.exports = __webpack_public_path__ + "static/media/video.3e0182b6.svg";